import script from "./CustomPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomPage.vue?vue&type=script&setup=true&lang=ts"

import "./CustomPage.vue?vue&type=style&index=0&id=2afe2088&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2afe2088"]])

export default __exports__